/**
 * Returns true when the given event target is a text-editing surface (input,
 * textarea, select or a `contenteditable` element). Used to suppress global
 * keyboard shortcuts while the user is typing.
 */
export const isEditableTarget = (target: EventTarget | null): boolean => {
  if (!(target instanceof HTMLElement)) {
    return false;
  }

  if (target.isContentEditable || target.contentEditable === 'true') {
    return true;
  }

  const tagName = target.tagName;

  return tagName === 'INPUT' || tagName === 'TEXTAREA' || tagName === 'SELECT';
};
